@if (code()) {
  <code>ngverse</code>
} @else {
  ngverse
}
